export const factories = [
  {
    id: 0,
    name: "全工場",
    shortName: "全工場",
  },
  {
    id: 50,
    name: "本社工場",
    shortName: "本社",
  },
  {
    id: 51,
    name: "本巣工場",
    shortName: "本巣",
  },
  {
    id: 52,
    name: "福岡工場",
    shortName: "福岡",
  },
  {
    id: 53,
    name: "熊本工場",
    shortName: "熊本",
  },
  {
    id: 54,
    name: "関東工場",
    shortName: "関東",
  },
  {
    id: 55,
    name: "屋井工場",
    shortName: "屋井",
  },
  {
    id: 58,
    name: "(株)守山製作所",
    shortName: "守山",
  },
  {
    id: 59,
    name: "その他外注",
    shortName: "その他外注",
  },
  {
    id: 62,
    name: "関東工場外注",
    shortName: "関東外注",
  },
  {
    id: 68,
    name: "熊本工場外注",
    shortName: "熊本外注",
  },
];
